export default __webpack_public_path__ + "static/media/invoke.8637f75f.mpeg";